export default "__VITE_ASSET__BXRXkFEQ__"